<template>
	<div>
		<div class="row mb-3">
			<div class="col-lg-2">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="VehiculoPermiso.Valor"
				></vue-numeric>
			</div>
			<div class="col-lg-7 form-group">
				<label>Proveedores</label>	
				<treeselect
					:disabled="DisabledProveedores"
					:maxHeight="100"
					@input="get_proveedores(proveedoresId)"
					:options="ListaProveedores"
					placeholder="Busque un proveedor..."
					v-model="VehiculoPermiso.IdProveedor"
					noResultsText="Resultados no encontrados"
					noOptionsText="Opciones no disponibles"
					:disable-fuzzy-matching="true"
				/>
			</div>
			<div class="col-lg-3">
				<label for="">Número Factura o Recibo</label>
				<input type="text" class="form-control" v-model="VehiculoPermiso.NumFactura">
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label for="">Fecha Factura o Recibo *</label>
                <v-date-picker v-model="VehiculoPermiso.Fecha" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-2">
				<label> Credito (días) </label>
				<!-- <input
					@input="sumDayPay()"
					class="form-control form-finanza"
					:precision="0"
					v-model="VehiculoPermiso.DiasCredito"
					placeholder="0"
				/> -->
				<select v-model="VehiculoPermiso.DiasCredito" class="form-control" @change="sumDayPay">
					<option value="0">Contado</option>
					<option value="15">15 días</option>
					<option value="30">30 días</option>
					<option value="60">60 días</option>
					<option value="90">90 días</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label for="">Fecha pago *</label>
                <v-date-picker v-model="VehiculoPermiso.FechaPago" :mode="typeCalendar"
					@input="sumDayPay()"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-4">
				<label>Factura</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="facturapermiso" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoFactura" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoPermiso.Observaciones" cols="10" rows="3"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Permiso",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Permiso',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoPermiso:{
                IdVehiculoPermiso:0,
                IdVehiculo:0,
                Fecha:'',
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:'',
				ArchivoFactura:''
            },
			ArchivoFactura:'',
            errorvalidacion:[],
			ListaProveedores: [],
			IndexPaqueteCta:0,
			DisabledProveedores:false
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
			let FechaPago='';
            if (this.VehiculoPermiso.Fecha!='' && this.VehiculoPermiso.Fecha!=undefined) {
                let day=this.VehiculoPermiso.Fecha.getDate();
                let month=this.VehiculoPermiso.Fecha.getMonth()+1;
                let year=this.VehiculoPermiso.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			if (this.VehiculoPermiso.FechaPago!='' && this.VehiculoPermiso.FechaPago!=undefined) {
                let day=this.VehiculoPermiso.FechaPago.getDate();
                let month=this.VehiculoPermiso.FechaPago.getMonth()+1;
                let year=this.VehiculoPermiso.FechaPago.getFullYear();
                FechaPago=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoPermiso',this.VehiculoPermiso.IdVehiculoPermiso);
            formData.set('IdVehiculo',this.VehiculoPermiso.IdVehiculo);
            formData.set('Valor',this.VehiculoPermiso.Valor);
			formData.set('NumFactura',this.VehiculoPermiso.NumFactura);
			formData.set('DiasCredito',this.VehiculoPermiso.DiasCredito);
			formData.set('IdProveedor',this.VehiculoPermiso.IdProveedor);
            formData.set('Observaciones',this.VehiculoPermiso.Observaciones);
			formData.set('ArchivoFactura',this.VehiculoPermiso.ArchivoFactura);
            formData.set('Fecha',Fecha);
			formData.set('FechaPago',FechaPago);
			let image=this.$refs.facturapermiso.files[0];
			formData.append('ArchivoFacturaFile',image);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculopermiso/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Permiso").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoPermiso={
                IdVehiculoPermiso:0,
                IdVehiculo:0,
                Fecha:new Date(),
				Valor:0,
                Observaciones:'',
				IdProveedor:null,
				NumFactura:'',
				DiasCredito:0,
				FechaPago:new Date(),
				ArchivoFactura:''
            },
			this.ArchivoFactura='Elegir archivo (0.5MB)';
			this.IndexPaqueteCta=0;
			this.DisabledProveedores=false;
        },
		Recuperar(){
            this.$http.get('vehiculopermiso/recovery',{
                params:{
                    IdVehiculoPermiso:this.VehiculoPermiso.IdVehiculoPermiso
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculopermiso;
                this.VehiculoPermiso.IdVehiculoPermiso=objres.IdVehiculoPermiso;
                this.VehiculoPermiso.IdVehiculo=objres.IdVehiculo;
                this.VehiculoPermiso.Valor=objres.Valor;
                this.VehiculoPermiso.Observaciones=objres.Observaciones;
				this.VehiculoPermiso.IdProveedor=objres.IdProveedor == 0 ? null : objres.IdProveedor;
				this.VehiculoPermiso.DiasCredito=objres.DiasCredito;
				this.VehiculoPermiso.NumFactura=objres.NumFactura;
				this.VehiculoPermiso.ArchivoFactura=objres.ArchivoFactura;
				this.VehiculoPermiso.Observaciones=objres.Observaciones;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoPermiso.Fecha=new Date(formatedDate);
				let formatedDate2 = objres.FechaPago.replace(/-/g, "\/");
                this.VehiculoPermiso.FechaPago=new Date(formatedDate2);
				this.ArchivoFactura=objres.ArchivoFactura;

            })
        },
		SubirArchivo(){
			const image = this.$refs.facturapermiso.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.facturapermiso;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.facturapermiso;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoFactura='Elegir archivo (0.5MB)';
                return false;
            }

            this.ArchivoFactura=image.name;
		},
		get_proveedores(id) {
			this.$http
				.get("ctaproveedores/get", {
					params: {}
				})
				.then(res => {
					this.ListaProveedores = res.data.data.proveedores.map(function(obj) {
						return { id: obj.IdProveedor, label: obj.Nombre };
					});
				});
		},
		sumDayPay() {
			let days = this.VehiculoPermiso.DiasCredito;
			let dateParam = this.VehiculoPermiso.Fecha;

			if (days > 0) {
				var date = new Date(dateParam);
				date.setDate(dateParam.getDate() + parseInt(days)); //sumamos días a la fecha recibida
				this.VehiculoPermiso.FechaPago = date; //fecha pago = fecha factura + días de crédito
			}
			else{
				this.VehiculoPermiso.FechaPago=this.VehiculoPermiso.Fecha;
			}
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
			this.get_proveedores();
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoPermiso.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoPermiso.IdVehiculoPermiso = Id;
				this.Recuperar();
			}

			let User=JSON.parse(sessionStorage.getItem("user"));
			this.IndexPaqueteCta=User.listaPaquetesPrincipal.findIndex((element)=>element.Paquete=='Cta. Cobrar y Pagar');
			if (this.IndexPaqueteCta==-1) {
				this.DisabledProveedores=true;
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
